/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateFileIndexPathParams, CandidateFileIndexResponse } from '../types/CandidateFileIndex'

/**
 * GET /candidates/:candidateId/files
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::index
 */
export async function candidateFileIndex(
	candidateId: CandidateFileIndexPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateFileIndexResponse>> {
	return axiosInstance.get(`/candidates/${candidateId}/files`, config)
}
